import React from 'react';
import { FileSystemEntry, fileSystemStore } from '../../store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { messageActions } from '../../action';
import { Button, ButtonGroup } from '../button';
import { fsApi } from '../../api';
import {
  faBoxOpen,
  faDownload,
  faEdit,
  faTimes,
  IconDefinition,
} from '@fortawesome/pro-regular-svg-icons';
import { lastPathSegment } from '../../util';

type FileActionButtonsProps = {
  fileSystemEntry: FileSystemEntry;
  downloadCallback: (fileName: string) => void;
};

export class FileActionButtons extends React.PureComponent<
  FileActionButtonsProps
> {
  render() {
    const { fileSystemEntry, downloadCallback } = this.props;

    return (
      <ButtonGroup style={{ justifyContent: 'flex-end' }}>
        {fileSystemEntry.name.endsWith('.zip') && (
          <ActionButton
            fileSystemEntry={fileSystemEntry}
            icon={faBoxOpen}
            title="Unzip"
            key={'unzip_' + fileSystemEntry.name}
            onClickCallback={() => {
              var result = prompt(`Destination folder name: `);
              if (result) {
                fsApi.unzipFile(
                  fileSystemEntry.name,
                  result,
                  fileSystemStore.tree.rootFolder.name,
                );
              }
            }}
          />
        )}

        {fileSystemEntry.type == 'File' && (
          <ActionButton
            fileSystemEntry={fileSystemEntry}
            icon={faDownload}
            title="Download"
            key={'download_' + fileSystemEntry.name}
            onClickCallback={() => {
              if (
                fileSystemEntry.size &&
                fileSystemEntry.size > 100 * 1024 * 1024
              ) {
                messageActions.msg('warning', 'Max file size is 100MB.');
                return;
              }
              downloadCallback(fileSystemEntry.name);
            }}
          />
        )}

        <ActionButton
          fileSystemEntry={fileSystemEntry}
          icon={faEdit}
          title="Rename"
          key={'rename_' + fileSystemEntry.name}
          onClickCallback={() => {
            var result = prompt(
              `New ${fileSystemEntry.type.toLowerCase()} name: `,
              lastPathSegment(fileSystemEntry.name),
            );
            if (result) {
              var newName = result;

              // If no extension was specified, append the existing extension on.
              if (!result.includes('.')) {
                var extensionStart = lastPathSegment(
                  fileSystemEntry.name,
                ).lastIndexOf('.');
                if (extensionStart > -1) {
                  newName += lastPathSegment(fileSystemEntry.name).substring(
                    extensionStart,
                  );
                }
              }

              fsApi.renameFileSystemEntry(fileSystemEntry.name, newName);
            }
          }}
        />
        <ActionButton
          fileSystemEntry={fileSystemEntry}
          icon={faTimes}
          title="Delete"
          key={'delete_' + fileSystemEntry.name}
          onClickCallback={() => {
            var result = confirm(
              `Are you sure you want to delete the ${fileSystemEntry.type.toLowerCase()} ` +
                `${lastPathSegment(fileSystemEntry.name)}?`,
            );
            if (result) {
              fsApi.deleteFileSystemEntries(
                [fileSystemEntry.name],
                fileSystemStore.tree.rootFolder.name,
              );
            }
          }}
        />
      </ButtonGroup>
    );
  }
}

interface ActionButtonProps {
  fileSystemEntry: FileSystemEntry;
  onClickCallback: () => void;
  icon: IconDefinition;
  title: string;
}

const ActionButton: React.FunctionComponent<ActionButtonProps> = props => (
  <Button
    size="small"
    aria-label={props.title}
    style={{ marginRight: '5px' }}
    title={props.title}
    onClick={props.onClickCallback}
  >
    <FontAwesomeIcon title={props.title} icon={props.icon} />
  </Button>
);
